"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityTypeInfoMap = void 0;
var managerMap = {
    icon: 'compass',
    entityType: 'manager',
    entityDefaultRoute: 'details',
    typeID: 11,
};
var organizationMap = {
    icon: 'place_buildings',
    entityType: 'organization',
    entityDefaultRoute: 'details',
    typeID: 8,
};
var benchmarkMap = {
    icon: 'gauge',
    entityType: 'benchmark',
    entityDefaultRoute: 'details',
    typeID: 35,
};
var investmentMap = {
    icon: 'diamond',
    entityType: 'investment',
    entityDefaultRoute: 'overview',
    typeID: 34,
};
var personMap = {
    icon: 'person',
    entityType: 'person',
    entityDefaultRoute: 'details',
    typeID: 6,
};
var userMap = {
    icon: 'account_circle',
    typeID: 7,
    entityType: 'organization',
    entityDefaultRoute: 'details',
};
var portfolioMap = {
    icon: 'briefcase',
    typeID: 50,
    entityType: 'organization',
    entityDefaultRoute: 'details',
};
exports.entityTypeInfoMap = {
    AD: organizationMap,
    AF: organizationMap,
    AP: portfolioMap,
    B: benchmarkMap,
    BB: organizationMap,
    BP: organizationMap,
    C: userMap,
    CA: investmentMap,
    CB: benchmarkMap,
    CE: investmentMap,
    EF: organizationMap,
    EQ: investmentMap,
    ET: investmentMap,
    FI: investmentMap,
    FU: investmentMap,
    HF: investmentMap,
    LF: organizationMap,
    M: managerMap,
    MF: investmentMap,
    OI: investmentMap,
    OP: investmentMap,
    PB: benchmarkMap,
    PE: investmentMap,
    Pn: personMap,
    SA: investmentMap,
    SP: organizationMap,
    SW: investmentMap,
    U: userMap,
    UNK: investmentMap,
    UO: organizationMap,
    manager: managerMap,
    organization: organizationMap,
    benchmark: benchmarkMap,
    investment: investmentMap,
    person: personMap,
    user: userMap,
    portfolio: portfolioMap,
    6: personMap,
    7: userMap,
    8: organizationMap,
    10: organizationMap,
    11: managerMap,
    13: organizationMap,
    14: organizationMap,
    15: organizationMap,
    16: organizationMap,
    17: organizationMap,
    20: userMap,
    34: investmentMap,
    35: benchmarkMap,
    36: investmentMap,
    37: investmentMap,
    38: investmentMap,
    39: investmentMap,
    40: investmentMap,
    41: investmentMap,
    42: investmentMap,
    43: investmentMap,
    44: investmentMap,
    45: investmentMap,
    46: investmentMap,
    47: investmentMap,
    48: investmentMap,
    49: investmentMap,
    50: portfolioMap,
    63: portfolioMap,
    67: investmentMap,
    68: benchmarkMap,
    83: benchmarkMap,
    84: investmentMap,
    96: investmentMap,
    97: investmentMap,
    98: investmentMap,
};
